import { startRazorpayCheckout, verifyRazorpayPayment } from '../api/payments'
import type { ApiCheckout } from '../api/types'
import { CHECKOUT_UI } from '../constants/orders'
import {
  PAYMENT_GATEWAY,
  type PaidGatewayPayment,
  type PaymentCheckoutSession,
  type PaymentCollectResult,
  type PaymentGatewayAdapter,
} from '../constants/payments'
import { readPaymentSession } from './payment-session'
import { openRazorpayCheckout } from './razorpay'

export const razorpayPaymentAdapter: PaymentGatewayAdapter = {
  gateway: PAYMENT_GATEWAY.razorpay,

  async start(checkoutId: string): Promise<PaymentCheckoutSession> {
    return readPaymentSession(await startRazorpayCheckout({ checkoutId }))
  },

  async collect(session: PaymentCheckoutSession, options): Promise<PaymentCollectResult> {
    if (!session.razorpay) {
      throw new Error(CHECKOUT_UI.paymentMissing)
    }
    const result = await openRazorpayCheckout(session.razorpay, options?.timeoutMs)
    if (result.status === 'expired') return { status: 'expired' }
    if (result.status !== 'paid') return { status: 'dismissed' }
    return {
      status: 'paid',
      gateway: PAYMENT_GATEWAY.razorpay,
      payment: result.payment,
    }
  },

  async verify(checkoutId: string, collected: PaidGatewayPayment): Promise<ApiCheckout> {
    if (collected.gateway !== PAYMENT_GATEWAY.razorpay) {
      throw new Error(CHECKOUT_UI.paymentMissing)
    }
    return verifyRazorpayPayment({
      checkoutId,
      razorpayOrderId: collected.payment.razorpay_order_id,
      razorpayPaymentId: collected.payment.razorpay_payment_id,
      razorpaySignature: collected.payment.razorpay_signature,
    })
  },
}
